module.exports = "<hospital-booking-header></hospital-booking-header>\n\n<main>\n  <div class=\"status\">\n    <span *ngIf=\"isSuccessful()\" class=\"icon -confirm\"></span>\n    <span *ngIf=\"!isSuccessful()\" class=\"icon -warning\"></span>\n    <p class=\"title\">{{ title }}</p>\n    <p class=\"subtitle\" *ngIf=\"subtitle\">{{ subtitle }}</p>\n  </div>\n</main>\n\n<hospital-booking-footer></hospital-booking-footer>"


//////////////////
// WEBPACK FOOTER
// ./ng2/hospital-booking/action-feedback/action-feedback.component.html
// module id = 771
// module chunks = 0